<div>
  {{ visibleText }}
  @if (hasMore) {
    <span class="more-label" [title]="moreText">{{ moreLabel }}</span>
  }
</div>
